module.exports = "<div class=\"modal-header heading\"><h3 class=modal-title>Warning</h3></div><div class=modal-body>A new version of KT Online has just been released, the version you are currently using is therefore out of date.<br/><br/>In order to avoid inconsistency, when you click reload we will reload all open KT Online tabs.</div><div class=modal-footer><button class=\"btn btn-cancel\" ng-click=modalCtrl.dismiss()>Cancel</button> <button class=\"btn btn-kt\" ng-click=modalCtrl.close()>Reload</button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/widgets/version-upgrade/version-upgrade-modal.html
// module id = 831
// module chunks = 0